/**
 * Base event class for the engine's event system
 */
export class Event {
  private readonly type: string;

  constructor(type: string) {
    this.type = type;
  }

  public getType(): string {
    return this.type;
  }
}
